export const theme = {
  colors: {
    accentGreen: "#88B13B",
    accentRed: "#FF6F61",
    backgroundBlue: "#F2F3F8",
    backgroundGray: "#F6F6FD",
    backgroundGray2: "#E6E7EC",
    backgroundGray3: "#F7F8FB",
    backgroundRed: "rgba(255, 111, 97, 0.1)",
    betterGreen: "#20CAA4",
    blackBlue: "#100F57",
    blackTextBody: "#2E353D",
    blackTextTitle: "#08082B",
    blue: "#3B4AD3",
    gray: "#989CA2",
    gray72: "#C6C8CE",
    grayNoRequired: "rgba(48, 52, 92, 0.4)",
    grayState: "rgba(48, 52, 92, 0.1)",
    lightGreen: "rgba(4, 221, 172, 0.1)",
    orangeText: "#FF9D5A",
    primaryBlue: "#002E6C",
    red: "#F71F20",
    secondaryLightBlue: "#00AEEF",
    stateBluebLack: "#30345C",
    supportLightBlue: "#06E5FF",
    supportRed: "#FF7C6F",
    supportYellow: "#FFECA3",
    tagGray: "rgba(23, 21, 120, 0.1)",
    white: "#FFFFFF",
  },

  // Percentages as names, example 10% transparency = p10
  transparencies: {
    p10: "1A",
    p20: "33",
    p30: "4D",
    p58: "94",
  },
  fontFamilies: {
    primaryFont: "'Montserrat', sans-serif",
  },
};
